/** What the reports' pages share: their button, status tones and messages. */
import { ApiError } from "../../api/client";
import type { ReportStatus, TicketState } from "../../api/types";
import type { BadgeTone } from "../../components/ui/Badge";

export const pillButton =
  "h-9 cursor-pointer rounded-pill border border-line bg-card px-4 text-sm font-medium " +
  "hover:bg-brand-tint disabled:cursor-not-allowed disabled:opacity-50";

// As the day view's ribbon colors each status (section 11.0), with its label.
export const STATUS_TONES: Record<ReportStatus, BadgeTone> = {
  needs_client: "needs-client",
  in_progress: "in-progress",
  ready: "neutral",
  not_logged: "needs-client",
  logging: "in-progress",
  logged: "logged",
  dismissed: "neutral",
};

// A ticket's state in words (ADR 0185), as the CSVs say it.
export const TICKET_STATE_LABELS: Record<TicketState, string> = {
  open: "Open",
  closing: "Closing",
  close_failed: "Close failed",
  closed: "Closed",
  unknown: "Status unknown",
  reopening: "Reopening",
};

// Closed is the goal: open asks for attention, a failed close more.
export const TICKET_STATE_TONES: Record<TicketState, BadgeTone> = {
  open: "in-progress",
  closing: "in-progress",
  close_failed: "needs-client",
  closed: "logged",
  unknown: "neutral",
  reopening: "in-progress",
};

export function errorMessage(error: unknown): string {
  if (error instanceof ApiError) {
    return error.detail ?? error.message;
  }
  return error instanceof Error ? error.message : "Something went wrong.";
}

// Refused (a filter the API won't take) is final; anything else, once more.
export function retryOnce(failures: number, error: Error): boolean {
  return !(error instanceof ApiError && error.status < 500) && failures < 1;
}

export function count(n: number, one: string, many: string): string {
  return `${String(n)} ${n === 1 ? one : many}`;
}
